<!-- <div id="notch-spacer"></div> -->
<div id="mbg-root-content" class="mat-app-background">
  <router-outlet></router-outlet>
</div>
